module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp23_5.09fb48e5.png";